import { render, staticRenderFns } from "./PanelControl.vue?vue&type=template&id=71f2bc78&scoped=true&"
import script from "./PanelControl.vue?vue&type=script&lang=js&"
export * from "./PanelControl.vue?vue&type=script&lang=js&"
import style0 from "./PanelControl.vue?vue&type=style&index=0&id=71f2bc78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f2bc78",
  null
  
)

export default component.exports